import { Component } from '@angular/core';

import { FieldBaseComponent } from '@shared/components/forms/components/field-base';
import { FormFieldErrorComponent } from '@shared/components/forms/components/form-field-error/form-field-error.component';
import { AppFileInputDirective } from './file-input.directive';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'lib-form-file',
  styleUrls: ['form-file.component.scss'],
  templateUrl: 'form-file.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    AppFileInputDirective,
    FormFieldErrorComponent,
  ],
})
export class FormFileComponent extends FieldBaseComponent {}
